<template>
  <div class="vhc-container">
    <!-- 标题栏 -->
    <pageTitle pageTitle="互动有礼">
      <div slot="content">
        1.直播中完成「填写指定问卷」任务后，观众立即获得礼品；观看回放时完成任务不赠送礼品
        <br />
        2.如果需要限制领取礼品人数、以及限制哪些人可领取哪些人不可领取，推荐使用「在线抽奖」功能
        <br />
        3.已推送问卷作为条件时，一旦创建互动有礼，将不可编辑
      </div>
    </pageTitle>

    <!-- tabs -->
    <vh-tabs class="interactive-prize-tabs" v-model="activeTab" @tab-click="handleTabClick">
      <vh-tab-pane label="任务列表" name="1">
        <TaskList v-if="activeTab === '1'"></TaskList>
      </vh-tab-pane>
      <vh-tab-pane label="礼品列表" name="2">
        <RewardList v-if="activeTab === '2'"></RewardList>
      </vh-tab-pane>
    </vh-tabs>

    <begin-play :webinarId="$route.params.str"></begin-play>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  import TaskList from './TaskList.vue';
  import RewardList from './RewardList.vue';
  import beginPlay from '@/components/beginBtn';

  export default {
    name: 'InteractReward',
    components: {
      PageTitle,
      TaskList,
      RewardList,
      beginPlay
    },
    data() {
      return {
        activeTab: '1'
      };
    },
    methods: {
      handleTabClick() {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            tab: this.activeTab
          }
        });
      }
    },
    created() {
      this.activeTab = this.$route.query.tab || '1';
    }
  };
</script>
<style lang="less">
  .interactive-prize-tabs {
    background-color: #fff;

    .vh-tabs__header {
      margin: 0;
      // padding: 0;
      .vh-tabs__nav-wrap {
        padding-right: 20px;
        &::after {
          background-color: #e6e6e6;
        }
      }
    }
    .vh-tabs__item {
      height: 48px;
      line-height: 48px;
      font-size: 16px;
    }
    .vh-tabs__content {
      // padding: 0;
    }
  }
</style>
